<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title54"></a>
<div class="p-c"><span><em class="i">In memoriam</em></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c"><span><strong class="b">Charles Sheffield</strong></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466824430_ded01.vue?5492f70a